// extracted by mini-css-extract-plugin
module.exports = {"cornerSprite":"style__cornerSprite__rqpLT","sideSprite":"style__sideSprite__A3wY8","middleSprite":"style__middleSprite__+Jusn"};